export default function checkSubjectMatch(subtest, subjects) {
  const matches = {
    ELA: ['English', 'Reading'],
    STEM: ['Math', 'Science'],
  }
  const matchCheck = matches[subjects]
  if (subtest.displayName === matchCheck[0] || subtest.displayName === matchCheck[1]) {
    return true
  } else {
    return false
  }
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/checkSubjectMatch.js